Vue.asyncComponent('ak-filters-dropdown', {
    props: {
        filters: {
            type: Object,
            required: true
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            hasOverflow: false,
            resizeObserver: null,
            mutationObserver: null,
        }
    },
    methods: {
        toggleDropdown() {
            this.open = !this.open;
        },
        closeDropdown() {
            this.open = false;
        },
        filterAdded(e) {
            this.$emit('filterAdded', e);
            this.$nextTick(this.closeDropdown);
        },
        checkOverflow() {
            const dropdown = this.$refs.dropdown;
            this.hasOverflow = dropdown.scrollHeight > (dropdown.scrollTop + dropdown.clientHeight + 12);
        }
    },
    mounted() {
        const dropdown = this.$refs.dropdown;
        dropdown.addEventListener('scroll', this.checkOverflow);

        this.mutationObserver = new MutationObserver(() => {
            requestAnimationFrame(this.checkOverflow);
        });

        this.resizeObserver = new ResizeObserver(() => {
            this.checkOverflow();
        });

        this.resizeObserver.observe(dropdown);

        this.mutationObserver.observe(
                dropdown,
            {
                childList: true,
                subtree: true,
                characterData: true,
            }
        );

        this.checkOverflow();
    },
    beforeDestroy() {
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();
        this.$refs.dropdown.removeEventListener('scroll', this.checkOverflow);
    }
}, 'grid/filters/ak-filters-dropdown.html');